import { useEffect } from "react";
import { X } from "lucide-react";

export const Drawer = ({ open, onClose, children, testId = "drawer" }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60]" data-testid={testId}>
      <div
        className="absolute inset-0 bg-stone-900/20"
        onClick={onClose}
        data-testid={`${testId}-backdrop`}
      />
      <div className="absolute right-0 top-0 h-full w-full max-w-[640px] bg-white border-l border-stone-200 shadow-xl flex flex-col">
        <button
          onClick={onClose}
          data-testid={`${testId}-close`}
          className="absolute -left-11 top-4 hidden sm:flex w-8 h-8 items-center justify-center rounded-full bg-white border border-stone-200 text-stone-600 hover:text-stone-900"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex-1 overflow-hidden">{children}</div>
      </div>
    </div>
  );
};

export const EvidenceButton = ({ onClick, answerability, testId = "open-evidence" }) => {
  const level = answerability?.trust_badge;
  const ink = level === "High" ? "text-emerald-700" : level === "Directional" ? "text-amber-700" : "text-rose-700";
  const dot = level === "High" ? "bg-emerald-600" : level === "Directional" ? "bg-amber-500" : "bg-rose-600";
  const fys = answerability?.fy_range || [];
  const fy = fys.length === 0 ? null : fys.length === 1 ? fys[0] : `${fys[0]}–${fys[fys.length - 1]}`;
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className="inline-flex items-center gap-1.5 text-[12px] text-stone-500 hover:text-stone-800 transition-colors"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      <span className={`font-semibold ${ink}`}>{level || "—"}</span>
      <span className="num">· n={answerability?.sample_size ?? 0}{fy ? ` · ${fy}` : ""}</span>
      <span className="text-[#A01236] font-medium ml-1">Evidence →</span>
    </button>
  );
};
